import React, { Component } from "react";
import CtDtp from "./CustomTool/CtDtp";
import { Grid, Box } from "@mui/material";
import Progress from "./CustomTool/Progress";
import { getRowColData } from "../SystemUtility/SystemUtility";
import CtCmbEditable from "./CustomTool/CtCmbEditable";
import CtTxtAmt from "./CustomTool/CtTxtAmt";
import CtBtn from "./CustomTool/CtBtn";
import TableList from "./CustomTool/TableList";
import { get_YMD_from_SYS } from "../SystemUtility/SystemUtility";
import { Delete, Edit } from "@mui/icons-material";
class ProductionEntry extends Component {
  state = {
    dataLoadStatus: true,
    // columns: [
    //   { id: "dtpDtate", label: "Date" },
    //   { id: "cmbRMStockid", label: "RM Stock Id" },
    //   { id: "cmbRMItemName", label: "RM Item Name" },
    //   { id: "cmbRMPacking", label: "RM Packing" },
    //   { id: "txtRMQty", label: "Consumed Qty." },
    //   { id: "cmbFGStockid", label: "FG Stock Id" },
    //   { id: "cmbFGItemName", label: "FG Item Name" },
    //   { id: "cmbFGPacking", label: "FG Packing" },
    //   { id: "txtFGQty", label: "Production Qty." },
    // ],
    // rows: [],
    actionList: [
      {
        name: "Edit",
        icon: <Edit />,
        // link: "PurchaseEntry:",
        // actionType: "AlertResponsive",
      },
      {
        name: "Delete",
        icon: <Delete />,
        // link: "PurchaseEntry:",
        // actionType: "AlertResponsive",
        // hide:
        //   this.props.userPrivilege.Purchase == "R" ||
        //   this.props.userPrivilege.Purchase == "W",
      },
    ],
    formData: {
      dtpDate: get_YMD_from_SYS(new Date()),
      cmbRMStockid: "",
      cmbRMItemName: "",
      cmbRMPacking: "",
      txtRMPackingWt: "",
      txtRMQty: "",
      txtRMTotalWt: "",
      cmbFGStockid: "",
      cmbFGItemName: "",
      cmbFGPacking: "",
      txtFGPackingWt: "",
      txtFGQty: "",
      txtFGTotalWt: "",
    },
  };

  //#region Handle
  handleOnChange = (e) => {
    this.setState(
      {
        formData: { ...this.state.formData, [e.target.name]: e.target.value },
      },
      () => {
        if (e.target.name == "txtRMQty" || e.target.name == "txtRMPackingWt") {
          this.TotalRMWt();
        } else if (
          e.target.name == "txtFGQty" ||
          e.target.name == "txtFGPackingWt"
        ) {
          this.TotalFGWt();
        }
      }
    );
  };
  //#endregion Handle

  //#region Function
  validatePurchaseItem = () => {
    let result = false;
    // if (this.state.formData.cmbItemName.length <= 0) {
    //   this.props.toastErrorMsg("Select Item Name", "cmbItemName");
    // } else if (
    //   isValidItem(
    //     this.state.ItemNameList,
    //     "vac_itemname",
    //     this.state.formData.cmbItemName
    //   ) == false
    // )
    // {
    //   this.props.toastErrorMsg("Select Valid Item Name", "cmbItemName");
    // }

    if (this.state.formData.cmbRMStockid.length <= 0) {
      this.props.toastErrorMsg("Select Stockid Name", "cmbRMStockid");
    } else if (this.state.formData.cmbRMItemName.length <= 0) {
      this.props.toastErrorMsg("Select Item Name", "cmbRMItemName");
    } else if (this.state.formData.cmbRMPacking.length <= 0) {
      this.props.toastErrorMsg("Select Packing Name", "cmbRMPacking");
    } else if (this.state.formData.txtRMQty <= 0) {
      this.props.toastErrorMsg("Enter Quantity", "txtRMQty");
    } else if (this.state.formData.cmbFGStockid.length <= 0) {
      this.props.toastErrorMsg("Select Stockid Name", "cmbFGStockid");
    } else if (this.state.formData.cmbFGItemName.length <= 0) {
      this.props.toastErrorMsg("Select Item Name", "cmbFGItemName");
    } else if (this.state.formData.cmbFGPacking.length <= 0) {
      this.props.toastErrorMsg("Select Packing Name", "cmbFGPacking");
    } else if (this.state.formData.txtFGQty <= 0) {
      this.props.toastErrorMsg("Enter Quantity", "txtFGQty");
    }
    //  else if (this.state.formData.txtRate <= 0) {
    //   this.props.toastErrorMsg("Enter Rate", "txtRate");}
    /* else if (this.state.formData.txtDis < 0) {
      this.props.toastErrorMsg("Enter Discount (%)", "txtDis");
    } else if (this.state.formData.txtDisAmt < 0) {
      this.props.toastErrorMsg("Enter Discount Amount", "txtDisAmt");
    } */
    //    else if (this.state.formData.cmbTaxName.length <= 0) {
    //       this.props.toastErrorMsg("Select Tax Name", "cmbTaxName");
    // }
    else {
      result = true;
    }
    return result;
  };

  clearInfo = () => {
    this.setState(
      {
        formData: {
          ...this.state.formData,
          dtpDate: get_YMD_from_SYS(new Date()),
          cmbRMStockid: "",
          cmbRMItemName: "",
          cmbRMPacking: "",
          txtRMPackingWt: "",
          txtRMTotalWt: "",
          txtRMQty: "",
          cmbFGStockid: "",
          cmbFGItemName: "",
          cmbFGPacking: "",
          txtFGPackingWt: "",
          txtFGTotalWt: "",
          txtFGQty: "",
        },
      },
      () => {
        document.getElementById("cmbRMStockid").focus();
      }
    );
  };

  TotalRMWt = () => {
    let txtRMTotalWt = 0;

    if (
      Number(this.state.formData.txtRMQty) > 0 &&
      Number(this.state.formData.txtRMPackingWt) > 0
    ) {
      txtRMTotalWt =
        Number(this.state.formData.txtRMQty) *
        Number(this.state.formData.txtRMPackingWt);
    }

    // console.log(txtRMTotalWt);
    this.setState({
      formData: {
        ...this.state.formData,
        txtRMTotalWt,
      },
    });
  };

  TotalFGWt = () => {
    let txtFGTotalWt = 0;

    if (
      Number(this.state.formData.txtFGQty) > 0 &&
      Number(this.state.formData.txtFGPackingWt) > 0
    ) {
      txtFGTotalWt =
        Number(this.state.formData.txtFGQty) *
        Number(this.state.formData.txtFGPackingWt);
    }
    this.setState({
      formData: {
        ...this.state.formData,
        txtFGTotalWt,
      },
    });
  };

  //#endregion Funtion

  render() {
    // let rows = this.state.searchOpen ? this.state.searchRows : this.state.rows;
    // let rowsCount = this.state.searchOpen
    //   ? this.state.searchRowsCount
    //   : this.state.rowsCount;
    return (
      <form>
        <Progress
          color="primary"
          display={this.state.dataLoadStatus !== true}
        />
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          className="title"
        >
          <label htmlFor="Title" style={{ fontSize: "30px", color: "#515151" }}>
            <b> Production Entry </b>
          </label>
        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="flex-end"
          spacing={2}
        >
          <Grid item>
            <CtDtp
              id="dtpDate"
              label="Date"
              width="150"
              handleOnChange={this.handleOnChange}
              defaultValue={this.state.formData.dtpDate}
              value={this.state.formData.dtpDate}
              // onKeyDown={this.props.onKeyDown}
              accountYear={localStorage.getItem("ACY")}
            />
          </Grid>
        </Grid>

        <Grid container justifyContent={"flex-start"} marginTop={2}>
          <Grid item lg={6} md={6} sm={12} xs={12}>
            <Grid
              container
              direction="column"
              justifyContent="flex-start"
              alignItems="flex-start"
              className="title"
              spacing={2}
            >
              <Grid item>
                <label
                  htmlFor="Title"
                  style={{ fontSize: "20px", color: "#515151" }}
                >
                  <b> Raw Material Consumption Details</b>
                </label>
              </Grid>
              <Grid item>
                <CtCmbEditable
                  id="cmbRMStockid"
                  label="RM Stock id*"
                  value={this.state.formData.cmbRMStockid}
                  handleOnChange={this.handleOnChange}
                  items={[]}
                  width={150}
                  maxLength={100}
                  // colID="vac_stockid"
                  // onKeyDown={this.props.onKeyDown}
                  // nextCtrlID="cmbItemName"
                />
              </Grid>
              <Grid item>
                <CtCmbEditable
                  id="cmbRMItemName"
                  label="RM Item Name*"
                  value={this.state.formData.cmbRMItemName}
                  handleOnChange={this.handleOnChange}
                  items={[]}
                  width={500}
                  maxLength={100}
                  // colID="vac_itemname"
                  // bolVisibleOnAddClickIcon={
                  //   this.props.userPrivilege.Item == "A" ? true : false
                  // }
                  // onAddClick={this.onAddClickItem}
                  // onKeyDown={this.props.onKeyDown}
                  // nextCtrlID="cmbPacking"
                />
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="flex-start"
              spacing={2}
              marginTop={0}
            >
              <Grid item>
                <CtCmbEditable
                  id="cmbRMPacking"
                  label="RM Packing*"
                  items={[]}
                  value={this.state.formData.cmbRMPacking}
                  // disabled={this.state.disabledProfileData.AccountTypeDS}
                  handleOnChange={this.handleOnChange}
                  width={120}
                  maxLength={100}
                  //   colID="vac_unit"
                  //   dataFilter={[
                  //     {
                  //       filterColID: "vac_itemname",
                  //       value: this.state.formData.cmbItemName,
                  //     },
                  //   ]}
                  //   onKeyDown={this.props.onKeyDown}
                  //   nextCtrlID="vac_packing"
                />
              </Grid>
              <Grid item>
                <CtTxtAmt
                  id="txtRMPackingWt"
                  label="RM Packing Wt."
                  value={this.state.formData.txtRMPackingWt}
                  handleOnChange={this.handleOnChange}
                  width={120}
                  maxLength={10}
                  //   onKeyDown={this.props.onKeyDown}
                  //   nextCtrlID="txtTotalWt"
                />
              </Grid>
              <Grid item>
                <CtTxtAmt
                  id="txtRMQty"
                  label="Consumed Qty.*"
                  value={this.state.formData.txtRMQty}
                  handleOnChange={this.handleOnChange}
                  width={120}
                  maxLength={10}
                  // nextCtrlID="txtPackingWt"
                  //   onKeyDown={this.props.onKeyDown}
                />
              </Grid>

              <Grid item>
                <CtTxtAmt
                  id="txtRMTotalWt"
                  disabled={true}
                  label="RM Total Wt."
                  value={this.state.formData.txtRMTotalWt}
                  handleOnChange={this.handleOnChange}
                  width={100}
                  maxLength={10}
                  //   onKeyDown={this.props.onKeyDown}
                  //   nextCtrlID="txtRate"
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item lg={6} md={6} sm={12} xs={12}>
            <Grid
              container
              direction="column"
              justifyContent="flex-start"
              alignItems="flext-start"
              className="title"
              spacing={2}
            >
              <Grid item>
                <label
                  htmlFor="Title"
                  style={{ fontSize: "20px", color: "#515151" }}
                >
                  <b>Finish Goods Production Details</b>
                </label>
              </Grid>
              <Grid item>
                <CtCmbEditable
                  id="cmbFGStockid"
                  label="FG Stock id*"
                  value={this.state.formData.cmbFGStockid}
                  handleOnChange={this.handleOnChange}
                  items={[]}
                  width={120}
                  maxLength={100}
                  // colID="vac_stockid"
                  // onKeyDown={this.props.onKeyDown}
                  // nextCtrlID="cmbItemName"
                />
              </Grid>

              <Grid item>
                <CtCmbEditable
                  id="cmbFGItemName"
                  label="FG Item Name*"
                  value={this.state.formData.cmbFGItemName}
                  handleOnChange={this.handleOnChange}
                  items={[]}
                  width={500}
                  maxLength={100}
                  // colID="vac_itemname"
                  // bolVisibleOnAddClickIcon={
                  //   this.props.userPrivilege.Item == "A" ? true : false
                  // }
                  // onAddClick={this.onAddClickItem}
                  // onKeyDown={this.props.onKeyDown}
                  // nextCtrlID="cmbPacking"
                />
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="flex-start "
              spacing={2}
              marginTop={0}
            >
              <Grid item>
                <CtCmbEditable
                  id="cmbFGPacking"
                  label="FG Packing*"
                  items={[]}
                  value={this.state.formData.cmbFGPacking}
                  // disabled={this.state.disabledProfileData.AccountTypeDS}
                  handleOnChange={this.handleOnChange}
                  width={120}
                  maxLength={100}
                  //   colID="vac_unit"
                  //   dataFilter={[
                  //     {
                  //       filterColID: "vac_itemname",
                  //       value: this.state.formData.cmbItemName,
                  //     },
                  //   ]}
                  //   onKeyDown={this.props.onKeyDown}
                  //   nextCtrlID="vac_packing"
                />
              </Grid>
              <Grid item>
                <CtTxtAmt
                  id="txtFGPackingWt"
                  label="FG Packing Wt."
                  value={this.state.formData.txtFGPackingWt}
                  handleOnChange={this.handleOnChange}
                  width={120}
                  maxLength={10}
                  //   onKeyDown={this.props.onKeyDown}
                  //   nextCtrlID="txtTotalWt"
                />
              </Grid>
              <Grid item>
                <CtTxtAmt
                  id="txtFGQty"
                  label=" Production Qty.*"
                  value={this.state.formData.txtFGQty}
                  handleOnChange={this.handleOnChange}
                  width={120}
                  maxLength={10}
                  //   nextCtrlID="txtPackingWt"
                  //   onKeyDown={this.props.onKeyDown}
                />
              </Grid>
              <Grid item>
                <CtTxtAmt
                  id="txtFGTotalWt"
                  disabled={true}
                  label="FG Total Wt."
                  value={this.state.formData.txtFGTotalWt}
                  handleOnChange={this.handleOnChange}
                  width={100}
                  maxLength={10}
                  //   onKeyDown={this.props.onKeyDown}
                  //   nextCtrlID="txtRate"
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item lg={6} md={6} sm={12} xs={12}>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              spacing={2}
              marginTop={0}
            >
              {" "}
              <Grid item>
                <CtBtn label="Save" onClick={this.savePurchaseItem} />
              </Grid>
              <Grid item>
                <CtBtn label="New" onClick={this.clearInfo} />
              </Grid>
              <Grid item>
                <CtBtn label="Delete" /* onClick={this.onDeleteBtnClick} */ />
              </Grid>
              <Grid item>
                <CtBtn
                  label="Production List"
                  //   onClick={() => {
                  //     this.props.navigateTo("PurchaseList");
                  //   }}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        {/* <Grid
            item
            display={
              this.props.userPrivilege.Purchase == "R" ? "none" : "block"
            }
          > */}

        {/* <Grid
            item
            display={
              this.props.userPrivilege.Purchase !== "M" ? "none" : "block"
            }
          > */}

        {/* </Grid> */}
        {/* </Grid> */}
        <br />
        {/* <Grid item>
          <Box display={{ xs: "none" }} style={{ textAlign: "right" }}>
            {this.state.ARD}
          </Box>
        </Grid> */}
        {/* <TableList
          columns={this.state.columns}
          counter={this.state.counter}
          //   rows={rows}
          //   rowsCount={rowsCount}
          //   rowsPerPage={this.state.rowsPerPage}
          //   handleChangeRowsPerPage={this.handleChangeRowsPerPage}
          //   handleOnActionClick={this.handleARDonActionClick}
          actionList={this.state.actionList}
          //   keyColumn={this.state.keyColumn}
          //   handleOnSearchChange={this.handleOnSearchChange}
          //   searchColumns={this.state.searchColumns}
          //   searchData={this.state.searchData}
          //   provideSearch={true}
          //   // provideSearch={true}
          //   handleOnNewEntryClick={this.handleOnNewEntryClick}
          //   toolTipNewEntry="Purchase Item Entry"
        /> */}
      </form>
    );
  }
}

export default ProductionEntry;
